<template>
    <div class="marketing-section">
        <h2 class="marketing-title fuente-posm">Marketing inteligente para tu negocio.</h2>
    </div>
</template>

<script>
export default {
    name: 'TituloMarketingNew'
}
</script>

<style lang="css" scoped>
.marketing-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    background-color: var(--color-2);
}

.marketing-title {
    color: var(--color-5);
    font-size: 80px;
    line-height: 1.1;
    text-align: center;
    max-width: 850px;
    margin: 0;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .marketing-title {
        font-size: 70px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .marketing-section {
        padding: 100px 20px 40px 20px;
    }

    .marketing-title {
        font-size: 35px;
    }
}
</style>
